import React, { useEffect, useRef, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import search_icon from '../assets/search.svg';
import personSearchIcon from '../assets/person_search.svg'
import arrowDown from '../assets/arrowDown.svg'


const RateVendorSelector = ({
    page,
    vendorError,
    setVendorError,
    vendorData,
    handleVendorSelect,
    device,
    selectedVendor,
    disabled // NEW: Disabled prop
}) => {
    const [inputValue, setInputValue] = useState("");
    const [selected, setSelected] = useState(selectedVendor || "");
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleOpen = () => {
        if (!disabled) setOpen(!open); // Prevent opening if disabled
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setSelected(selectedVendor || "");
    }, [selectedVendor]);

    return (
        <div
            className={`w-full relative cursor-pointer `}
            ref={dropdownRef}
        >
            <div
                onClick={handleOpen}
                className={`w-full h-[45px] mg:h-[50px]  md:shadow-none md:border-none ${vendorError === "Vendor is required" || vendorError === "Invalid Search"
                    ? " border border-[#EB0728] "
                    : "md:bg-none border border-ravgray "
                    } rounded-[80px] md:rounded-l-none py-[14px] px-[13px] flex items-center justify-between text-center text-base lg:text-sm font-medium ${!selected && "text-[#707070]"
                    } ${disabled ? "bg-ravbg text-ravash cursor-not-allowed" : "shadow-search bg-white "}`}
            >
                {selected
                    ? selected?.length > 15
                        ? selected?.substring(0, 15) + "..."
                        : selected
                    : <div className={`flex gap-[5px] font-normal text-base lg:text-sm ${vendorError && "text-[#EB0728]"}`}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            className={`size-[20px] ${vendorError ? "text-[#EB0728]" : "text-[#707070]"}`}
                            fill="currentColor"
                        >
                            <path d="M440-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T520-640q0-33-23.5-56.5T440-720q-33 0-56.5 23.5T360-640q0 33 23.5 56.5T440-560ZM884-20 756-148q-21 12-45 20t-51 8q-75 0-127.5-52.5T480-300q0-75 52.5-127.5T660-480q75 0 127.5 52.5T840-300q0 27-8 51t-20 45L940-76l-56 56ZM660-200q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-540 40v-111q0-34 17-63t47-44q51-26 115-44t142-18q-12 18-20.5 38.5T407-359q-60 5-107 20.5T221-306q-10 5-15.5 14.5T200-271v31h207q5 22 13.5 42t20.5 38H120Zm320-480Zm-33 400Z" />
                        </svg>
                        Vendor
                    </div>}
                {device === "small" && !disabled ?
                    <svg
                        width="13"
                        height="9"
                        viewBox="0 0 13 9"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`${vendorError ? "text-[#EB0728]" : "text-[#707070]"} ${open && "rotate-180"}`}
                        fill="currentColor"
                    >
                        <path d="M6.5 8.04167L0.25 1.79167L1.36979 0.671875L6.5 5.80208L11.6302 0.671875L12.75 1.79167L6.5 8.04167Z" />
                    </svg>
                    : null}
            </div>

            {!disabled && open && (
                <ul className="w-full shadow-input bg-white mt-2 overflow-y-auto flex flex-col absolute rounded-md z-50 text-start h-[30vh]">
                    <div className="flex items-center px-2 sticky top-0 bg-white text-base lg:text-sm">
                        <AiOutlineSearch size={18} className="text-gray-700" />
                        <input
                            type="text"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value.toLowerCase())}
                            placeholder="Enter vendor name"
                            className="placeholder:text-[#707070] p-2 outline-none text-base lg:text-sm"
                        />
                    </div>
                    {vendorData
                        ?.sort((a, b) => a?.vendor_name?.localeCompare(b?.vendor_name))
                        ?.map((vendor) => (
                            <li
                                key={vendor?.vendor_id}
                                className={`p-2 text-sm hover:bg-sky-600 hover:text-white
                                    ${vendor?.vendor_name?.toLowerCase() === selected?.toLowerCase() && "bg-sky-600 text-white"}
                                    ${vendor?.vendor_name?.toLowerCase().startsWith(inputValue) ? "block" : "hidden"}
                                `}
                                onClick={() => {
                                    if (vendor?.vendor_name?.toLowerCase() !== selected.toLowerCase()) {
                                        setSelected(vendor?.vendor_name);
                                        handleVendorSelect(vendor?.vendor_name, vendor?.vendor_id);
                                        setOpen(false);
                                        setInputValue("");
                                    }
                                }}
                            >
                                {vendor?.vendor_name}
                            </li>
                        ))}
                </ul>
            )}
        </div>
    );
};

export default RateVendorSelector;

